//
//
//
//

import OverrideCustomizations from "../override-customizations.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CoBrokeringTab",
  components: {
    OverrideCustomizations
  }
});